import { useNavigate } from 'react-router-dom';
import type { FilaDeCartera } from '@/api/cartera.api';
import { chatDe } from '@/lib/cartera';

/**
 * Lo que hace «Chat» con un cliente (tanda 6): abre su conversación en el panel o, si todavía
 * no ha escrito y tiene teléfono, su WhatsApp en otra pestaña (no manda nada). Devuelve
 * `undefined` cuando no hay a dónde ir: así el botón no se dibuja.
 */
export function useAbrirChat(): (fila: Pick<FilaDeCartera, 'conversacion' | 'telefono'>) => (() => void) | undefined {
  const navigate = useNavigate();
  return (fila) => {
    const chat = chatDe(fila);
    if (!chat) return undefined;
    return () => {
      if ('ruta' in chat) navigate(chat.ruta);
      else window.open(chat.url, '_blank', 'noopener,noreferrer');
    };
  };
}
